<template>
  <div class="children-general">
    <div v-if="selectedChild === null">
      Selecteer een kind
    </div>
    <div v-else class="row">
      <template v-for="(child, childIndex) in childData" v-bind:key="childIndex">
        <template v-for="(data, dataIndex) in child" v-bind:key="dataIndex">
          <div class="col-12 mb-1 mt-3">
            <a :id="data.title"></a>
            <h4>{{ translate(data.title) }}</h4>
          </div>
          <template v-for="(dataField, dataFieldIndex) in data.fields" v-bind:key="dataFieldIndex">
            <div class="col-12 col-sm-6 d-flex">
              <div
                  v-if="dataField.icon && dataField.icon.type === 'icon'"
                  style="margin-right: 4px;"
              >
                  <i
                      v-if="
                        dataField.fieldType === 'radio'
                        &&
                        dataField.value
                        &&
                        dataField.formOptions
                        &&
                        dataField.formOptions[dataField.value]
                        &&
                        dataField.formOptions[dataField.value].color
                      "
                      :class="dataField.icon.class"
                      :style="'color:' + dataField.formOptions[dataField.value].color"
                  ></i>
                  <i
                      v-else-if="dataField.icon.color"
                      :class="dataField.icon.class"
                      :style="{color: dataField.icon.color}"
                  ></i>
                  <i v-else
                     :class="dataField.icon.class"
                  ></i>

              </div>
              <div v-if="dataField.name === 'General practitioner'">
                  <div
                      v-for="(embeddedData, embeddedDataIndex) in dataField.displayValue"
                      v-bind:key="embeddedDataIndex"
                  >
                      {{ translate(embeddedDataIndex) }}
                  </div>
              </div>
              <div v-else>
                  {{ translate(dataField.name) }}
              </div>
            </div>
            <div class="col-11 col-sm-5" style="max-width: 50%">
              <template v-if="dataField.editable && dataField.edit && dataField.edit === true">
                <div v-if="dataField.fieldType === 'select' || dataField.fieldType === 'radio'">
                  <select v-model="dataField.value"
                          @change="changeValue($event, dataField.functionName, dataField.edit_id)">
                    <option>Selecteer</option>
                    <template v-if="dataField.functionName.startsWith('custom_')">
                      <option :value="key" v-for="(value, key) in dataField.formOptions" v-bind:key="key">{{ value.name }}</option>
                    </template>
                    <template v-else>
                      <option :value="option.id" v-for="option in dataField.formOptions" v-bind:key="option.id">{{ option.name }}</option>
                    </template>
                  </select>
                </div>
                <div v-else-if="dataField.fieldType === 'textarea'">
                  <div>
                    <textarea-plus
                        :value="dataField.value"
                        @onChange="setCustomValue(dataField.functionName, $event)">
                    </textarea-plus>
                  </div>
                  <div v-if="
                        dataField.editable
                        && dataField.edit
                        && dataField.edit === true"
                       @click="saveCustomValue(
                           dataField.functionName)"
                       class="col-1">
                    <h6>Opslaan</h6>
                  </div>
                </div>
                <div v-else-if="dataField.fieldType === 'text'">
                  <input type="text"
                         v-model.lazy="dataField.value"
                         @change="setCustomValue(dataField.functionName, dataField.value)"
                  >
                  <div v-if="
                        dataField.editable
                        && dataField.edit
                        && dataField.edit === true"
                       @click="saveCustomValue(
                           dataField.functionName)"
                       class="col-1">
                    <h6>Opslaan</h6>
                  </div>
                </div>
                <div v-else-if="dataField.fieldType === 'number'">
                  <input
                      v-model.number="dataField.value"
                      @change="changeValue($event, dataField.functionName, dataField.edit_id)"
                      @keypress="isNumber($event)"
                  >
                  <span v-if="notNumeric" class=" alert-danger"><br>{{ translate('Enter numbers only') }}</span>
                </div>
              </template>
              <template v-else>
                  <div v-if="dataField.name.startsWith('General practitioner')">
                      <div
                          v-for="(embeddedData, embeddedDataIndex) in dataField.displayValue"
                          v-bind:key="embeddedDataIndex"
                      >
                          {{ translate(embeddedData) }}
                      </div>
                  </div>
                  <div v-else>
                      {{ translate(dataField.displayValue) }}
                  </div>
              </template>
            </div>
            <div v-if="dataField.editable && dataField.edit && dataField.edit === true"
                 @click="stopEditField(childIndex, dataIndex, dataFieldIndex)" class="col-1">
              <h6>Annuleer</h6>
            </div>
            <div v-else-if="dataField.editable" @click="editField(childIndex, dataIndex, dataFieldIndex)" class="col-1">
              <h6>Bewerk</h6>
            </div>
          </template>
        </template>
      </template>
    </div>

    <span
        v-if="
        getApplicationSetting('feature_flag_ipad_activities_tiles_view') === '1'
      "
    >
      <div class="row">
        <div class="col-12 mt-3">
          <h3>Huidige activiteit</h3>
        </div>
        <div class="col-12">
          <span
              v-if="selectedChild.status && selectedChild.status.activities && selectedChild.status.activities.length > 0">
            <activity-list-item
                v-bind:key="activity.id"
                v-for="activity in selectedChild.status.activities"
                :activity="activity"
            ></activity-list-item>
          </span>
          <span v-else>Geen activiteit</span>
        </div>
      </div>

      <br/>
    </span>


    <div v-if="getApplicationSetting('ipad_child_thumbnail_photos') !== '0'" class="row">
      <div class="col-12">
        <h3>Profielfoto</h3>
      </div>
      <div class="col-12 col-sm-3">Foto</div>
      <div class="col-12 col-sm-4">
        <child-thumbnail :key="selectedChild.id_child" :childReset="selectedChild.reset" :child="selectedChild"
                         type="select"/>
      </div>
      <div class="col-12 col-sm-5">
        <button
            type="button"
            name="uploadPhoto"
            class="btn btn-secondary"
            @click="uploadPhoto()"
        >
          Nieuwe foto
        </button>
        <br/>
        <button
            type="button"
            name="verwijderPhoto"
            class="btn btn-secondary"
            @click="isModelDelete = true"
            style="margin-top: 10px"
        >
          Verwijder foto
        </button>
        <br>
        <div style="margin-top: 10px;">
          <button :disabled="isRotating" class="btn btn-secondary" @click="rotatePhoto('left')">
            Draaien <img :src="require('@/assets/rotate-clock-wise.svg')">
          </button>
        </div>
      </div>
    </div>

    <modal v-if="isModal">
      <template v-slot:header>
        <h3 class="modal-title">Nieuw profielfoto uploaden</h3>
        <button v-on:click="isModal = false">
          <span class="btn-close">
            <span aria-hidden="true">&times;</span>
          </span>
        </button>
      </template>
      <template v-slot:body>
        <div style="padding: 20px">
          <div class="form-group">
            <div class="col-sm-10">
              <span v-if="isUploading">
                Nieuwe profielfoto van het kind wordt verwerkt, een moment
                geduld.
              </span>
              <span v-else>
                Selecteer nieuw profielfoto:
                <input
                    type="file"
                    id="photo"
                    ref="photo"
                    class="form-control"
                /><br/>
              </span>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <button
              class="btn btn-outline-info"
              type="button"
              name="upload"
              value="upload"
              @click="isModal = false"
          >
            Annuleer
          </button>
          <button
              class="btn btn-info"
              type="button"
              name="upload"
              value="upload"
              @click="uploadSave()"
          >
            Opslaan
          </button>
        </div>
      </template>
    </modal>

    <modal v-if="isModelDelete">
      <template v-slot:header>
        <h3 class="modal-title">Profielfoto verwijderen</h3>
        <button v-on:click="isModelDelete = false">
          <span class="btn-close">
            <span aria-hidden="true">&times;</span>
          </span>
        </button>
      </template>
      <template v-slot:body>
        <div style="padding: 20px">
          <div class="form-group">
            <div class="col-sm-10">
              Je staat op het punt de profielfoto van het kind te verwijderen,
              weet je zeker dat je wilt doorgaan?
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <button
              class="btn btn-outline-info"
              type="button"
              name="upload"
              value="upload"
              @click="isModelDelete = false"
          >
            Annuleer
          </button>
          <button
              class="btn btn-info"
              type="button"
              name="upload"
              value="upload"
              @click="deletePhoto()"
          >
            Doorgaan
          </button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "@/components/Modal";
import ActivityListItem from "@/components/Activity-List-Item";
import ChildThumbnail from "@/components/Child-Thumbnail";
import TextareaPlus from "@/components/Textarea-Plus";

export default {
  name: "children-general",
  props: ["id"],
  components: {
    ActivityListItem,
    Modal,
    ChildThumbnail,
    TextareaPlus
  },
  data() {
    return {
      thumbPhoto: false,
      editMode: false,
      mentorEmployees: [],
      designatedEmployees: [],
      loading: 0,
      isModal: false,
      isModelDelete: false,
      isUploading: false,
      isRotating: false,
      childData: {},
      notNumeric: false,
      customFields: []
    };
  },
  created() {
    this.scrollToAnchor()
    this.getChild()
  },
  methods: {
    scrollToAnchor() {
      const app = this
      setTimeout(function () {
        if(app.$route.hash) {
          const el = document.querySelector();
          el && el.scrollIntoView();
        }
      })
    },
    getChild() {
      this.isLoading = true
      this.$request.get('/children/forms?id_child=' + this.selectedChild.id)
          .then((response) => {
            this.isLoading = false
            if (!response.data) {
              return
            }
              this.childData = response.data
              this.scrollToAnchor()
          })
    },
    editField: function (childIndex, dataIndex, dataFieldIndex) {
      let child = this.childData[childIndex];
      child[dataIndex].fields[dataFieldIndex].edit = true;
      this.childData[childIndex] = child;
    },
    stopEditField: function (childIndex, dataIndex, dataFieldIndex) {
      let child = this.childData[childIndex];
      child[dataIndex].fields[dataFieldIndex].edit = false;
      this.childData[childIndex] = child;
    },
    changeValue: function (event, functionCall, editIndex) {
      if (functionCall.startsWith('custom_')) {
        this.updateCustomField(functionCall.replace('custom_', ''), event.target.value);
      } else if (functionCall === 'mentor') {
        this.selectMentor(editIndex, event.target.value)
      } else if (functionCall === 'designatedEmployee') {
        this.selectdesignatedEmployee(editIndex, event.target.value)
      } else {
        this.updateChildField(functionCall, event.target.value)
      }
    },
    updateCustomField: function (field, value) {
      let custom = {};
      custom[field] = value
      this.$request.post('/children/custom-fields', {
        id_child: this.selectedChild.id,
        custom: custom,
      }).then(() => {
        this.getChild()
      });
    },
    selectMentor: function (number, idEmployee) {
      this.$request.post('/deprecated/set-child-mentor', {
        id_child: this.selectedChild.id,
        id_mentor: idEmployee,
        number: number
      }).then(() => {
        this.getChild()
      });
    },
    selectdesignatedEmployee: function (number, idEmployee) {
      this.$request.post('/deprecated/set-child-designated-employee', {
        id_child: this.selectedChild.id,
        number: number,
        id_designated_employee: idEmployee,
      }).then(() => {
        this.isLoading = false;
        this.getChild()
      });
    },
    updateChildField: function (functionCall, value) {
      this.$request.post('/children/update-fields', {
        id_child: this.selectedChild.id,
        fields: [
          {
            value: value,
            name: functionCall
          }
        ],
      }).then(() => {
        this.isLoading = false;
        this.getChild()
      });
    },
    uploadPhoto() {
      this.isModal = true;
    },
    closeModal() {
      this.isModal = false;
    },
    uploadSave() {
      this.isUploading = true;
      let files = this.$refs.photo.files;
      let formData = new FormData();
      formData.append("bestand", files[0]);
      formData.append("fotonaam", this.selectedChild.id);
      formData.append("session_token", this.session.session_token);
      formData.append("device_token", this.deviceToken);
      this.$request.post('/deprecated/upload-child-profile-photo', formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
      ).then((response) => {
        if (!response || !response.data || !response.data.image) {
          this.isUploading = false;
          alert(
              "Er is een fout opgetreden tijdens uploaden, probeer opnieuw"
          );
        } else {
          this.isUploading = false;
          this.isModal = false;
          this.selectedChild.reset += 1;
          this.$store.dispatch('updateChildInfo', this.selectedChild.id, false, '')
        }
      })
    },
    deletePhoto() {
      this.$request.post('/deprecated/delete-child-profile-photo', {
        id_child: this.selectedChild.id
      }).then((response) => {
        if (!response) {
          this.isModelDelete = false;
          alert(
              "Er is een fout opgetreden tijdens het verwijderen, probeer opnieuw"
          );
        } else {
          if (response.data.success) {
            this.thumbPhoto = false;
            this.isModelDelete = false;
            this.selectedChild.reset += 1;
            this.$store.dispatch('updateChildInfo', this.selectedChild.id, false, '')
          }
        }
      })
    },
    rotatePhoto(rotateType) {
      this.isRotating = true
      this.$request.post('/deprecated/rotate-child-profile-photo', {
        id_child: this.selectedChild.id,
        rotateType: rotateType
      }).then((response) => {
        this.$store.commit("REMOVE_ACTIVE_REQUEST");
        if (!response) {
          this.isRotating = false;
          alert(
              "Er is een fout opgetreden tijdens uploaden, probeer opnieuw"
          );
        } else {
          this.isRotating = false;
          this.thumbPhoto = response.data.thumb_image
          this.selectedChild.reset += 1;
          this.$store.dispatch('updateChildInfo', this.selectedChild.id, false, '')
        }
      })
    },
    setCustomValue(name, value) {
      this.customFields[name] = {'customNr': name.replace('custom_', ''), 'value': value}
    },
    saveCustomValue(name) {
      if (name.startsWith('custom_')) {
        this.updateCustomField(this.customFields[name].customNr, this.customFields[name].value)
      } else {
        this.updateChildField(name, this.customFields[name].value)
      }
    },
    isNumber: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        this.notNumeric = true;
        evt.preventDefault();
      } else {
        this.notNumeric = false;
        return true;
      }
    }
  },
  watch: {
    selectedChild() {
      this.getChild()
    }
  },
};
</script>

<style scoped>
.thumbnail {
  position: relative;
  top: 0;
  left: 0;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background-repeat: no-repeat !important;
  background-attachment: fixed;
  background-position: center;
  background-size: cover !important;
}

.fa {
  color: rgb(188, 198, 211);
  margin-right: 5px;
  margin-bottom: 5px;
}
</style>
